import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const telegram = defineConnector({
  identifier: "telegram",
  name: "Telegram",
  tagLine: "Cloud-based messaging",
  keywords: "tg chat messaging bot botfather channels groups",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.telegram\\.org/.*",
  auth: customAuth("telegram"),
  steps: [
    {
      title: "Create a bot with BotFather",
      items: [
        {
          kind: "markdown",
          content:
            "Open Telegram and search for [@BotFather](https://t.me/BotFather). Start a conversation and use the `/newbot` command to create a new bot.\n\nFollow the prompts to choose a name and username for your bot. Once created, BotFather will provide you with an API token.",
        },
      ],
    },
    {
      title: "Enter your bot token",
      items: [
        {
          kind: "markdown",
          content:
            "Copy the HTTP API token that BotFather gave you. It looks like `123456789:ABCdefGHIjklMNOpqrsTUVwxyz`.",
        },
        {
          kind: "input",
          label: "Bot token",
          placeholder: "123456789:ABCdefGHIjklMNOpqrsTUVwxyz",
          required: true,
          target: { kind: "secrets", field: "botToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.telegram.org/getMe",
  },
});
